import React from "react";
import "./LocalAidMainPage.css";
import { Route, Switch } from "react-router-dom";
import LocalAid from "./localAidPage/LocalAid";
import SubmitRequ from "./submitRequPage/SubmitRequ";
import RequestsLobby from "./requestsLobyPage/RequestsLobby";
import LocalAidProfile from "./localAidProfilePage/LocalAidProfile";
import LocalAidRelatives from "./localAidRelativesPage/LocalAidRelatives";
import LinkAccount from "./linkAccount/LinkAccount";
import LocalAidRelation from "./LocalAidRelation/LocalAidRelation";
import LocalAidReg from "./localAidReg/LocalAidReg";

function LocalAidMainPage() {
  return (
    <div className="local_aid_main_page">
      <Switch>
        <Route path="/localAid/" component={LocalAid} exact />
        <Route
          path="/localAid/setup-information"
          component={LocalAidReg}
        />
        <Route path="/localAid/submit-request" component={SubmitRequ} />
        <Route path="/localAid/requests" component={RequestsLobby} />
        <Route path="/localAid/localAidProfile" component={LocalAidProfile} />
        <Route path="/localAid/relatives" component={LocalAidRelatives} />
        <Route path="/localAid/link-account" component={LinkAccount} />
        <Route path="/localAid/local-aid-relation" component={LocalAidRelation} />
      </Switch>
    </div>
  );
}

export default LocalAidMainPage;
